import type { UnderlyingHistorics } from 'components/shared/UnderlyingHistos/UnderlyingHistoModels';
import type { AppState } from 'state/state.model';

import type { UnderlyingHistoModalState } from './underlyingHisto.model';

function selectUnderlyingHistoModalState(appState: AppState): UnderlyingHistoModalState {
  return appState.underlyingHistoModal;
}

export function isUnderlyingHistographFetchingFailed(appState: AppState): boolean {
  const state = selectUnderlyingHistoModalState(appState);
  return state.isFetchingFailed;
}

export function isUnderlyingHistographFetching(appState: AppState): boolean {
  const state = selectUnderlyingHistoModalState(appState);
  return state.isFetching;
}

export function getUnderlyingHistorics(appState: AppState): UnderlyingHistorics {
  const state = selectUnderlyingHistoModalState(appState);
  return state.underlyingsHistorics;
}

export function getUnderlyingHistoError(appState: AppState): string {
  const state = selectUnderlyingHistoModalState(appState);
  return state.errorMessage ?? '';
}
